import React, { memo, useState } from "react";
import styled from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import ShowMoreButton from "@components/atoms/Filters/ShowMoreButton";
import { VDBText } from "@components/atoms";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTranslation } from "react-i18next";
import { CPSSubsectionNames } from "../TextListSection/types";
import { ProductCategory } from "@utils/constants";

const ColumnSection = ({
  data = [],
  children = [],
  direction = "column",
  selectedProduct = ProductCategory.DIAMOND,
}: any) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const typography = useTypographyStore();
  const maxChildren = data?.max_row ?? children.length;
  const [showAll, setShowAll] = useState<boolean>(!data?.max_row);

  const visibleChildren = children.slice(0, maxChildren);
  const hiddenChildren = children.slice(maxChildren, children.length);

  const expandView = () => {};

  return (
    <ListView>
      {data?.display_title && (
        <TextContainer>
          <VDBText type={typography["H3-M"]} color={theme["core-05"]}>
            {t(data?.label)}
          </VDBText>
        </TextContainer>
      )}
      <ChildrenContainer direction={direction}>
        {data?.name === CPSSubsectionNames.CPS
          ? React.Children.map(visibleChildren, (child) =>
              React.isValidElement(child)
                ? React.cloneElement(child, { expandView } as any)
                : child
            )
          : visibleChildren}
        <HiddenChildrenContainer direction={direction} showAll={showAll}>
          {hiddenChildren}
        </HiddenChildrenContainer>
      </ChildrenContainer>
      <ButtonContainer>
        <ShowMoreButton
          options={data?.sub_filters || []}
          columns={1}
          showAll={showAll}
          onPressFunction={setShowAll}
          displayedRows={data?.max_row || 0}
          selectedProduct={selectedProduct}
        />
      </ButtonContainer>
    </ListView>
  );
};

const ListView = styled.View`
  flex-direction: column;
  gap: ${SpaceType.Extra}px;
`;

const ChildrenContainer = styled.View<{
  direction?: string;
}>`
  flex-direction: row;
  gap: ${SpaceType.Basic}px;
  width: 100%;
`;

const HiddenChildrenContainer = styled.View<{
  direction?: string;
  showAll?: boolean;
}>`
  ${({ direction }: { direction?: string }) =>
    direction === "row"
      ? `flex-direction: row; flex-wrap: wrap;`
      : `flex-direction: column;`}
  gap: ${SpaceType.Basic}px;

  ${({ showAll }: { showAll?: boolean }) =>
    showAll ? "" : "height: 0px; overflow: hidden;"}
`;

const ButtonContainer = styled.View`
  padding-horizontal: ${SpaceType.Double}px;
  margin-top: ${-SpaceType.Extra}px;
`;

const TextContainer = styled.View`
  margin-left: ${SpaceType.Double}px;
`;

export default memo(ColumnSection);
